const categories = [
  { id: 1, icon: 'ri-rocket-2-line', name: '星际战争', count: '2,386 部', color: 'text-primary-500', bg: 'bg-primary-50' },
  { id: 2, icon: 'ri-planet-line', name: '太空冒险', count: '1,954 部', color: 'text-accent-500', bg: 'bg-accent-50' },
  { id: 3, icon: 'ri-aliens-line', name: '外星文明', count: '1,672 部', color: 'text-primary-600', bg: 'bg-primary-50' },
  { id: 4, icon: 'ri-ship-line', name: '星际舰队', count: '1,438 部', color: 'text-accent-600', bg: 'bg-accent-50' },
  { id: 5, icon: 'ri-time-line', name: '时空穿越', count: '1,205 部', color: 'text-primary-500', bg: 'bg-primary-50' },
  { id: 6, icon: 'ri-flask-line', name: '科幻悬疑', count: '1,089 部', color: 'text-accent-500', bg: 'bg-accent-50' },
  { id: 7, icon: 'ri-shield-star-line', name: '超级英雄', count: '976 部', color: 'text-primary-600', bg: 'bg-primary-50' },
  { id: 8, icon: 'ri-building-2-line', name: '未来都市', count: '843 部', color: 'text-accent-600', bg: 'bg-accent-50' },
  { id: 9, icon: 'ri-meteor-line', name: '末日生存', count: '712 部', color: 'text-primary-500', bg: 'bg-primary-50' },
];

export default function Index() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            按题材分类浏览，快速找到你喜欢的科幻漫画
          </p>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-9 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href="#index"
              className="flex flex-col items-center gap-2 p-3 md:p-4 bg-background-100 rounded-lg border border-background-200/60 hover:border-accent-300/50 transition-colors no-underline cursor-pointer group"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full ${cat.bg} flex items-center justify-center`}>
                <i className={`${cat.icon} ${cat.color} text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-semibold text-foreground-800 whitespace-nowrap group-hover:text-primary-600 transition-colors">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">
                {cat.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}